<template>
  <div class="animated fadeIn">
    <b-row class="animated fadeIn fadeOut" style="cursor:pointer">
      <b-col sm="12" v-if="setting">
        <b-form-checkbox class="pull-left m-2" v-model="setting.DRUPAL.use" @change="toggle($event, setting.DRUPAL.key, 'DRUPAL')" :indeterminate="setting.DRUPAL.indeterminate" :disabled="service_lock">
          <b-img style="cursor:pointer" v-bind="ico" src="ico/drupal.ico" alt="Drupal"></b-img> DRUPAL
          <!-- {{setting.DRUPAL.key}} -->
        </b-form-checkbox>
        <b-form-checkbox class="pull-left m-2" v-model="setting.WORDPRESS.use" @change="toggle($event, setting.WORDPRESS.key, 'WORDPRESS')" :indeterminate="setting.WORDPRESS.indeterminate" :disabled="service_lock">
          <b-img style="cursor:pointer" v-bind="ico" src="ico/wordpress.ico" alt="WORDPRESS"></b-img> WORDPRESS
          <!-- {{setting.WORDPRESS.key}} -->
        </b-form-checkbox>
        <b-form-checkbox class="pull-left m-2" v-model="setting.JAVA.use" @change="toggle($event, setting.JAVA.key, 'JAVA')" :indeterminate="setting.JAVA.indeterminate" :disabled="service_lock">
          <b-img style="cursor:pointer" v-bind="ico" src="ico/java.ico" alt="JAVA"></b-img> JAVA
          <!-- {{setting.JAVA.key}} -->
        </b-form-checkbox>
        <b-form-checkbox class="pull-left m-2" v-model="setting.PHP.use" @change="toggle($event, setting.PHP.key, 'PHP')" :indeterminate="setting.PHP.indeterminate" :disabled="service_lock">
          <b-img style="cursor:pointer" v-bind="ico" src="ico/php.ico" alt="PHP"></b-img> PHP
          <!-- {{setting.PHP.key}} -->
        </b-form-checkbox>
        <b-form-checkbox class="pull-left m-2" v-model="setting.IIS.use" @change="toggle($event, setting.IIS.key, 'IIS')" :indeterminate="setting.IIS.indeterminate" :disabled="service_lock">
          <b-img style="cursor:pointer" v-bind="ico" src="ico/iis.ico" alt="Drupal"></b-img> IIS
          <!-- {{setting.IIS.key}} -->
        </b-form-checkbox>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
